// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"96533eb7","181":"4b44764c","576":"2ce474ce"}[chunkId] + ".chunk.css";
};